/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@madmobile/concierge-connect-web-components/loader';
defineCustomElements();
export const CcAccordion = /*@__PURE__*/ createReactComponent('cc-accordion');
export const CcAccordionItem = /*@__PURE__*/ createReactComponent('cc-accordion-item');
export const CcAppFooter = /*@__PURE__*/ createReactComponent('cc-app-footer');
export const CcBackButton = /*@__PURE__*/ createReactComponent('cc-back-button');
export const CcBadge = /*@__PURE__*/ createReactComponent('cc-badge');
export const CcBadgeQuantity = /*@__PURE__*/ createReactComponent('cc-badge-quantity');
export const CcBagCard = /*@__PURE__*/ createReactComponent('cc-bag-card');
export const CcBagCardThumbnail = /*@__PURE__*/ createReactComponent('cc-bag-card-thumbnail');
export const CcButton = /*@__PURE__*/ createReactComponent('cc-button');
export const CcCarousel = /*@__PURE__*/ createReactComponent('cc-carousel');
export const CcCatalogButton = /*@__PURE__*/ createReactComponent('cc-catalog-button');
export const CcCatalogGridItem = /*@__PURE__*/ createReactComponent('cc-catalog-grid-item');
export const CcCheckbox = /*@__PURE__*/ createReactComponent('cc-checkbox');
export const CcCol = /*@__PURE__*/ createReactComponent('cc-col');
export const CcColorItem = /*@__PURE__*/ createReactComponent('cc-color-item');
export const CcColorPicker = /*@__PURE__*/ createReactComponent('cc-color-picker');
export const CcErrorModal = /*@__PURE__*/ createReactComponent('cc-error-modal');
export const CcFancyText = /*@__PURE__*/ createReactComponent('cc-fancy-text');
export const CcFilterItem = /*@__PURE__*/ createReactComponent('cc-filter-item');
export const CcFilters = /*@__PURE__*/ createReactComponent('cc-filters');
export const CcFitGuide = /*@__PURE__*/ createReactComponent('cc-fit-guide');
export const CcGrid = /*@__PURE__*/ createReactComponent('cc-grid');
export const CcHero = /*@__PURE__*/ createReactComponent('cc-hero');
export const CcIcon = /*@__PURE__*/ createReactComponent('cc-icon');
export const CcIconAccount = /*@__PURE__*/ createReactComponent('cc-icon-account');
export const CcIconAdd = /*@__PURE__*/ createReactComponent('cc-icon-add');
export const CcIconArrowBack = /*@__PURE__*/ createReactComponent('cc-icon-arrow-back');
export const CcIconArrowForward = /*@__PURE__*/ createReactComponent('cc-icon-arrow-forward');
export const CcIconBag = /*@__PURE__*/ createReactComponent('cc-icon-bag');
export const CcIconBarcode = /*@__PURE__*/ createReactComponent('cc-icon-barcode');
export const CcIconButton = /*@__PURE__*/ createReactComponent('cc-icon-button');
export const CcIconCaret = /*@__PURE__*/ createReactComponent('cc-icon-caret');
export const CcIconCheck = /*@__PURE__*/ createReactComponent('cc-icon-check');
export const CcIconClose = /*@__PURE__*/ createReactComponent('cc-icon-close');
export const CcIconEdit = /*@__PURE__*/ createReactComponent('cc-icon-edit');
export const CcIconFavorite = /*@__PURE__*/ createReactComponent('cc-icon-favorite');
export const CcIconFilter = /*@__PURE__*/ createReactComponent('cc-icon-filter');
export const CcIconFind = /*@__PURE__*/ createReactComponent('cc-icon-find');
export const CcIconHome = /*@__PURE__*/ createReactComponent('cc-icon-home');
export const CcIconItem = /*@__PURE__*/ createReactComponent('cc-icon-item');
export const CcIconLanguage = /*@__PURE__*/ createReactComponent('cc-icon-language');
export const CcIconMenu = /*@__PURE__*/ createReactComponent('cc-icon-menu');
export const CcIconRemove = /*@__PURE__*/ createReactComponent('cc-icon-remove');
export const CcIconSend = /*@__PURE__*/ createReactComponent('cc-icon-send');
export const CcIconShop = /*@__PURE__*/ createReactComponent('cc-icon-shop');
export const CcIconSort = /*@__PURE__*/ createReactComponent('cc-icon-sort');
export const CcKeyboard = /*@__PURE__*/ createReactComponent('cc-keyboard');
export const CcLocationCard = /*@__PURE__*/ createReactComponent('cc-location-card');
export const CcMenuToggle = /*@__PURE__*/ createReactComponent('cc-menu-toggle');
export const CcMobileHeader = /*@__PURE__*/ createReactComponent('cc-mobile-header');
export const CcModal = /*@__PURE__*/ createReactComponent('cc-modal');
export const CcModalLayout = /*@__PURE__*/ createReactComponent('cc-modal-layout');
export const CcNavPopout = /*@__PURE__*/ createReactComponent('cc-nav-popout');
export const CcNavigation = /*@__PURE__*/ createReactComponent('cc-navigation');
export const CcNavigationItem = /*@__PURE__*/ createReactComponent('cc-navigation-item');
export const CcPopover = /*@__PURE__*/ createReactComponent('cc-popover');
export const CcPopoverConfirmation = /*@__PURE__*/ createReactComponent('cc-popover-confirmation');
export const CcPopoverRadio = /*@__PURE__*/ createReactComponent('cc-popover-radio');
export const CcProductCard = /*@__PURE__*/ createReactComponent('cc-product-card');
export const CcRadioGroup = /*@__PURE__*/ createReactComponent('cc-radio-group');
export const CcRangeInput = /*@__PURE__*/ createReactComponent('cc-range-input');
export const CcRow = /*@__PURE__*/ createReactComponent('cc-row');
export const CcSectionCarousel = /*@__PURE__*/ createReactComponent('cc-section-carousel');
export const CcSizePicker = /*@__PURE__*/ createReactComponent('cc-size-picker');
export const CcSizePickerItem = /*@__PURE__*/ createReactComponent('cc-size-picker-item');
export const CcSmallTotal = /*@__PURE__*/ createReactComponent('cc-small-total');
export const CcTab = /*@__PURE__*/ createReactComponent('cc-tab');
export const CcTabs = /*@__PURE__*/ createReactComponent('cc-tabs');
export const CcTextButton = /*@__PURE__*/ createReactComponent('cc-text-button');
export const CcTextInput = /*@__PURE__*/ createReactComponent('cc-text-input');
export const CcTextInputEmbed = /*@__PURE__*/ createReactComponent('cc-text-input-embed');
export const CcToggle = /*@__PURE__*/ createReactComponent('cc-toggle');
export const CcTracker = /*@__PURE__*/ createReactComponent('cc-tracker');
export const CcTrackerSpacer = /*@__PURE__*/ createReactComponent('cc-tracker-spacer');
export const CcTrackerStep = /*@__PURE__*/ createReactComponent('cc-tracker-step');
//# sourceMappingURL=components.js.map